// Global context for parsed tournaments — persists across tab navigation
import React, { createContext, useContext, useState } from 'react';
import { ParsedTournament } from '../utils/pokerCraftParser';

interface ParsedCtx {
  tournaments: ParsedTournament[];
  setTournaments: (t: ParsedTournament[]) => void;
  clear: () => void;
}

export const ParsedTournamentsContext = createContext<ParsedCtx>({
  tournaments: [],
  setTournaments: () => {},
  clear: () => {},
});

export function ParsedTournamentsProvider({ children }: { children: React.ReactNode }) {
  const [tournaments, setTournaments] = useState<ParsedTournament[]>([]);
  return React.createElement(
    ParsedTournamentsContext.Provider,
    { value: { tournaments, setTournaments, clear: () => setTournaments([]) } },
    children
  );
}

export const useParsedTournaments = () => useContext(ParsedTournamentsContext);
